const types = {
  CLEAR_CURRENT: 'SERVICES_CLEAR_CURRENT',
  GET_REQUEST: 'SERVICES_GET_REQUEST',
  GET_SUCCESS: 'SERVICES_GET_SUCCESS',
  GET_FAILURE: 'SERVICES_GET_FAILURE',

  SAVE_REQUEST: 'SERVICES_SAVER_REQUEST',
  SAVE_SUCCESS: 'SERVICES_SAVE_SUCCESS',
  SAVE_FAILURE: 'SERVICES_SAVE_FAILURE',

  GETALL_REQUEST: 'SERVICES_GETALL_REQUEST',
  GETALL_SUCCESS: 'SERVICES_GETALL_SUCCESS',
  GETALL_FAILURE: 'SERVICES_GETALL_FAILURE',

  DELETE_REQUEST: 'SERVICES_DELETE_REQUEST',
  DELETE_SUCCESS: 'SERVICES_DELETE_SUCCESS',
  DELETE_FAILURE: 'SERVICES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'SERVICES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'SERVICES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'SERVICES_UPDATE_FAILURE'    

};

export default types;